export default function Disclaimer() {
  return (
    <div className="max-w-4xl mx-auto p-6 md:mt-20 text-gray-800 leading-relaxed">
      <h1 className="text-3xl font-bold mb-4">DISCLAIMER</h1>

      <p>
        The services, including the website and the content, are provided “as is”
        and without warranties of any kind, either express or implied. To the
        fullest extent permissible pursuant to applicable law, wiinnergame and its
        affiliated companies, licensors, suppliers, partners and sponsors, and
        each of their respective directors, officers, agents, contractors,
        advisors, employees and suppliers (“released entities”) disclaim all
        warranties, express or implied, including, without limitation, implied
        warranties of title, non-infringement, accuracy, merchantability and
        fitness for a particular purpose.
      </p>

      <h2 className="text-xl font-semibold mt-5">wiinnergame does not warrant that:</h2>
      <ul className="list-disc ml-6 mt-2">
        <li>The services or content will meet your requirements.</li>
        <li>The services or content will be available at any time or location.</li>
        <li>The services or content will be accurate, secure, timely, or error-free.</li>
        <li>Defects or errors will be corrected.</li>
        <li>The services are free of viruses or harmful components.</li>
      </ul>

      <p className="mt-4">
        All or a portion of the Services may be unavailable from time to time for
        maintenance or other reasons. wiinnergame assumes no responsibility for
        any interruption, deletion, defect, delay, transmission failure, theft,
        destruction, unauthorized access, or technical malfunction of any kind.
      </p>

      <p className="mt-4">
        Under no circumstances will wiinnergame be responsible for any loss,
        damage, personal injury, or death resulting from use of the Services.
        Nothing in these Terms seeks to limit liability for death or personal
        injury caused by negligence, fraud, or fraudulent misrepresentation.
      </p>

      <h2 className="text-xl font-semibold mt-5">Warranty Disclaimer & Limitation of Liability</h2>
      <p className="mt-2">
        To the fullest extent permitted by law, wiinnergame makes no warranties,
        express or implied, including merchantability, fitness for a particular
        purpose, or non-infringement.
      </p>

      <p className="mt-4">
        In no event shall any released entity be liable for loss of data, profit,
        revenue, use, or any indirect, incidental, consequential, exemplary, or
        punitive damages, whether foreseeable or not.
      </p>

      <p className="mt-4">
        The total liability of wiinnergame shall not exceed the course fees paid
        by the user related to the service claiming such liability.
      </p>

      <p className="mt-4">
        If any provision of these terms becomes invalid or unenforceable, it shall
        be severed without affecting the validity of the remaining provisions.
      </p>
    </div>
  );
}
